<!-- 企业级-无人仓业务-配置设置 -->
<template>
  <div class="mainArea CExpressCompany">
    <div class="searchDiv mt20 mb20">
      <div class="dib"><el-input placeholder="请输入快递公司" v-model="keyword.name" clearable @keyup.enter.native="getCompanyList(1)"></el-input></div>
      <div class="dib">
        <el-select v-model="keyword.status" placeholder="状态" clearable @change="getCompanyList(1)">
          <el-option label="正常" value="1"></el-option>
          <el-option label="禁用" value="-1"></el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="getCompanyList(1)">搜索</el-button>
    </div>
    <div class="btn mb20">
      <el-button type="primary" @click="openDio('add')">添加</el-button>
    </div>
    <div class="tabList">
      <el-table :data="compList" style="width: 100%" v-loading="tableLoading">
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column label="LOGO">
          <template slot-scope="scope">
            <div class="logoImg"><img :src="scope.row.logo_url" alt=""></div>
          </template>
        </el-table-column>
        <el-table-column label="快递公司" sortable prop="express_name"></el-table-column>
        <el-table-column label="手机号码" sortable prop="phone"></el-table-column>
        <el-table-column label="邮箱" sortable prop="email"></el-table-column>
        <el-table-column label="创建时间" sortable prop="create_time"></el-table-column>
        <el-table-column label="状态" sortable prop="express_state" width="100">
          <template slot-scope="scope">
            <el-button class="success" type="text" v-if="scope.row.express_state == '1'" @click="statusTips(scope.row.id,scope.row.express_state)">正常</el-button>
            <el-button class="error" type="text" v-if="scope.row.express_state == '-1'" @click="statusTips(scope.row.id,scope.row.express_state)">禁用</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="openDio('edit',scope.row)">修改</el-button>
          </template>
        </el-table-column>
        
      </el-table>
    </div>
    <div class="paging" v-if="total>page">
      <el-pagination
        @current-change="CurrentChange"
        :current-page.sync="curr"
        @size-change="sizeChange"
        :page-size="page"
        :page-sizes="[10,50,100,1000]"
        layout="total,sizes,prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="diaTit" :visible.sync="isDio" width="480px" class="dioDiv">
      <div class="contDio">
        <el-form ref="form" :rules="rules" :model="dioform" label-width="90px">
          <el-form-item label="公司名:" prop="name">
            <el-input v-model="dioform.name" placeholder="请输入快递公司名称"></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="phone">
            <el-input v-model="dioform.phone" placeholder="请输入联系号码"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="email">
            <el-input v-model="dioform.email" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="LOGO:" prop="logoUrl">
            <el-upload
              class="logo-uploader"
              action="#"
              accept="image/*"
              :show-file-list="false"
              :http-request="uploadImage">
              <img v-if="dioform.logoUrl" :src="dioform.logoUrl" class="avatar">
              <i v-else class="el-icon-plus logo-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="submitForm('form')">确定</el-button>
      </span>
    </el-dialog>

    <!--更改状态-->
    <el-dialog title="" :visible.sync="statusDio" width="300" class="statusDio">
      <div class="statusCont">
        <div>当前状态为 <b v-if="statusform.status == '-1'">禁用</b><b v-else>正常</b></div>
        <div>是否将状态改为 <b v-if="statusform.status == '-1'">正常</b><b v-else>禁用</b>？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="statusDio = false">取 消</el-button>
        <el-button type="primary" v-if="statusform.status == '-1'" @click="changeStatus">正 常</el-button>
        <el-button type="primary" v-else @click="changeStatus">禁 用</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast } from "../../../../static/js/utility/utility.js"
  import { bussinessApi,userApi } from "../../../../static/js/api.js"
  var vm
  export default {
    name: 'CExpressCompany',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        keyword:{
          name:'',//公司名搜索
          status:'',//状态
        },

        compList:[],//公司列表
        tableLoading:false,

        //分页
        curr:1,//当前页
        page:10,//显示个数
        total:0,//总数据
        
        //弹窗信息
        diaTit:'',
        isDio:false,
        dioform:{
          type:'',//打开弹窗的类型（添加or修改）
          id:'',
          name:'',
          phone:'',
          email:'',
          logoUrl:'',
        },

        //form验证
        rules: {
          name: [
            { required: true, message: '请输入快递公司名称', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入联系电话', trigger: 'blur' },
          ],
          email: [
            { required: true, message: '请输入邮箱', trigger: 'blur' },
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ],
          logoUrl: [
            { required: true, message: '请上传LOGO', trigger: 'blur' },
          ],
        },

        statusDio:false,//修改状态
        statusform:{
          id:'',
          status:'',
        },
      };
    },
    mounted(){

    },
    created: async function () {
      vm = this
      this.getCompanyList()
    },
    methods: {
      //修改状态
      async changeStatus(){
        const data = {
          'id':vm.statusform.id,
          'express_state':vm.statusform.status == '-1' ?'1':'-1',
        }
        const res = await bussinessApi.saveExpressStatus(data)
        if (res.meta.code === 200) {
          showToast('状态修改成功！')
          vm.getCompanyList(1)
          vm.statusDio = false
        } else {
          showToast(res.meta.message)
        }
      },
      //打开状态修改弹窗
      statusTips(id,status){
        vm.statusform.id = id;
        vm.statusform.status = status;
        vm.statusDio = true
      },

      //提交form
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            vm.SaveExpress()
          } else {
            
            return false;
          }
        });
      },
      //打开更新信息弹窗
      openDio(type,data){
        vm.dioform.type = type
        if(type == 'add'){
          vm.diaTit = '添加'
          vm.dioform.id=''
          vm.dioform.name=''
          vm.dioform.phone=''
          vm.dioform.email=''
          vm.dioform.logoUrl=''
        }else if(type == 'edit'){
          vm.diaTit = '修改'
          vm.dioform={
            type: type,
            id: data.id,
            name: data.express_name,
            phone: data.phone,
            email: data.email,
            logoUrl: data.logo_url,
          }
        }
        vm.isDio = true
      },
      //更新公司信息
      async SaveExpress(){
        var data = {
          'express_name':vm.dioform.name,
          'logo_url':vm.dioform.logoUrl,
          'email':vm.dioform.email,
          'phone':vm.dioform.phone,
        }
        if(vm.dioform.type == 'edit'){
          data.id=vm.dioform.id

        }
        const res = await bussinessApi.SaveExpress(data)
        if (res.meta.code === 200) {
          if(vm.dioform.type == 'add'){
            showToast('添加成功！')
          }else{
            showToast('修改成功！')
          }
          vm.getCompanyList(1)
          vm.isDio = false
        } else {
          showToast(res.meta.message)
        }
      },
      
      //获取快递公司列表
      async getCompanyList(curr,limits){
        this.tableLoading = true
        const data = {
          'express_name': vm.keyword.name,//公司名关键词搜索
          'express_state': vm.keyword.status,//状态搜索
          'page':curr ? curr : vm.curr,//当前页
          'perPage': limits ? limits : vm.page,//每页条数
        }
        let res = await bussinessApi.GetExpress(data)
        if(res.meta.code == 200){
          vm.compList = res.data.list
          vm.total = parseInt(res.data.total)
          vm.tableLoading = false
        }else{
          vm.tableLoading = false
          showToast(res.meta.message)
        }
      },
      //分页
      CurrentChange(val) {
        this.curr = val
        // console.log(`当前页: ${val}`);
        this.getCompanyList(val)
      },
      sizeChange (val) {
        console.log('val', val)
        this.page = val
        this.getCompanyList(1)
      },

      //图片上传
      // 上传图片
      async uploadImage(content) {
        console.log('content', content)
        let formData = new FormData()
        formData.append('file', content.file)
        let res = await userApi.uploadImage(formData)
        if (res.meta.code === 200) {
          // vm.fileList = [content.file.name]
          vm.dioform.logoUrl = res.data
          showToast('上传成功')
        } else {
          showToast(res.meta.message)
        }
      },
    },
    watch: {
      
      
    }
  }
</script>

<style lang="scss">
.CExpressCompany{
  .el-table{
    .success{
      color: #67C23A;
    }
    .error{
      color: #F56C6C;
    }
    .edit{
      font-size: 24px;
      color: #409EFF;
    }
    .logoImg{
      width: 64px;
      height: 64px;
      border: 1px solid #ddd;
      margin: 0 auto;
      img{
        object-fit: scale-down;
        width: 100%;
      }
    }
  }
  .dioDiv{
    .logo-uploader{
      .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409EFF;
      }
      .logo-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      .avatar {
        width: 100px;
        height: 100px;
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CExpress/CExpressCompany.vue